import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    projectPrefix: string;
    folderPrefix: string;
    asset: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Screen reader prefix for project type */
            projectPrefix: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_GetScreenReaderText.projectPrefix?c=14bndfs8xpffs", defaultMessage: "Project: " }));
                },
                enumerable: true,
                configurable: true
            },
            /** Screen reader prefix for folder type */
            folderPrefix: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_GetScreenReaderText.folderPrefix?c=1rapzbq1f3t7b", defaultMessage: "Folder: " }));
                },
                enumerable: true,
                configurable: true
            },
            /** Word "Asset" as used in asset type labels (e.g. "Video Asset") */
            asset: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_GetScreenReaderText.asset?c=3iaauhnn1nf4m", defaultMessage: "Asset" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
